import React, { Component, createRef } from 'react';

// CSS
import '../Subscriptions/Subscription.scss';

// Helper
import { checkCookie } from '../../Helper/Cookies';
import { apiFetch, getCurrentUser } from '../../Helper/Api';

// Components
import Header from '../../components/Header/Header';
import { Modal, Confirm } from '../../components/UI/Overlays';
import { EmptyState, TableWait, Tip } from '../../components/UI/Feedback';
import { Toolbar, SelectEmpty } from '../../components/UI/Controls';
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

// Properties
const properties = require('../../properties.json');

class Materials extends Component {
    constructor(props) {
        super(props);
        this.toast = createRef(null);
    }

    state = {
        branchID: getCurrentUser()?.branchId,
        globalFilter: null,
        userInput: null,
        selectedStage: null,
        getSchoolStages: [],
        data: [],
        editableData: null,
        visible: false,

        // ---- the page's own states ----
        loadingStages: true,
        tableLoading: false,
        saving: false,
        adding: false,

        // Adding happens in a card over the list, and the stage it asks
        // for is ITS OWN: picking one in the card must not re-filter the
        // table behind it. It only starts from whatever is being viewed.
        addOpen: false,
        addStage: null,

        // the material the teacher asked to delete, held while the card is up
        doomed: null,
        deleting: false,
    }

    getSchoolStages() {
        const user = getCurrentUser();
        if (!user) return;
        this.setState({ loadingStages: true });
        apiFetch("/lookup/school-stages/by-teacher", { query: { teacherUserId: user.userId } })
            .then(stages => {
                this.setState({ getSchoolStages: stages, loadingStages: false });
            })
            .catch(error => {
                this.setState({ loadingStages: false });
                console.error('Error:', error);
            });
    }

    getMaterialsByStage = (stageId) => {
        this.setState({ selectedStage: stageId }, () => {
            if (!stageId) {
                this.setState({ data: [], tableLoading: false });
                return;
            }
            this.setState({ tableLoading: true });
            apiFetch("/lookup/materials/by-stage", { query: { stageId } })
                .then(materials => {
                    this.setState({ data: materials, tableLoading: false });
                })
                .catch(error => {
                    this.setState({ tableLoading: false });
                    console.error('Error:', error);
                });
        });
    }

    componentDidMount() {
        document.title = properties.site_name + " | المواد";
        // Redirect To Sign In Page If The User Is Already Logged Out & Remove The Data If It Exists
        if (!checkCookie('name')) {
            window.localStorage.removeItem('currentTeacher');
            window.location.href = `/`;
        }
        this.getSchoolStages();
    }

    addMaterial = () => {
        var _this = this;
        const stageId = this.state.addStage;
        if (!this.state.userInput || !stageId) {
            _this.toast.current.show({ severity: 'error', summary: 'تنبيه', detail: 'إختر المرحلة الدراسية وإسم المادة' });
            return;
        }
        this.setState({ adding: true });
        apiFetch("/lookup/materials", {
            method: "POST",
            body: {
                name: this.state.userInput,
                stageId: stageId,
                branchId: this.state.branchID,
            },
        })
            .then(() => {
                _this.toast.current.show({ severity: 'success', summary: 'تم بنجاح', detail: 'تمت الإضافة بنجاح' });
                this.setState({ userInput: null, adding: false, addOpen: false });
                // show the stage it was just added to, so the new material
                // is on the screen that was asked for
                this.getMaterialsByStage(stageId);
            })
            .catch(error => {
                console.error('Error:', error);
                this.setState({ adding: false });
                _this.toast.current.show({ severity: 'error', summary: 'لم تتم العملية', detail: error.message || 'خطأ في الإتصال' });
            });
    }

    render() {
        const { data, tableLoading, selectedStage, doomed, deleting } = this.state;

        let schoolStages = this.state.getSchoolStages.map(stage => ({ label: stage.name, value: stage.id }));
        const stage = this.state.getSchoolStages.find((s) => s.id === selectedStage);

        // The question is asked in the product's own card now. The call
        // after "yes" is the one that was always there -- including the
        // message the server sends back when the material is still in use.
        var deleteMaterial = (row) => {
            var _this = this;
            this.setState({ deleting: true });
            apiFetch(`/lookup/materials/${row.id}`, { method: "DELETE" })
                .then(() => {
                    this.setState({ doomed: null, deleting: false });
                    this.getMaterialsByStage(this.state.selectedStage);
                    _this.toast.current.show({ severity: 'success', summary: 'تم بنجاح', detail: 'تم الحذف بنجاح' });
                })
                .catch(error => {
                    console.error('Error:', error);
                    this.setState({ doomed: null, deleting: false });
                    _this.toast.current.show({ severity: 'error', summary: 'لم تتم العملية', detail: error.message || 'خطأ في الإتصال' });
                });
        }

        var editMaterial = () => {
            var _this = this;
            this.setState({ saving: true });
            apiFetch(`/lookup/materials/${this.state.editableData.id}`, {
                method: "PUT",
                body: {
                    name: this.state.editableData.name,
                    stageId: this.state.selectedStage,
                    branchId: this.state.branchID,
                },
            })
                .then(() => {
                    _this.toast.current.show({ severity: 'success', summary: 'تم بنجاح', detail: 'تم التعديل بنجاح' });
                    this.getMaterialsByStage(this.state.selectedStage);
                    this.setState({ visible: false, saving: false });
                })
                .catch(error => {
                    console.error('Error:', error);
                    this.setState({ saving: false });
                    _this.toast.current.show({ severity: 'error', summary: 'لم تتم العملية', detail: error.message || 'خطأ في الإتصال' });
                });
        }

        // the one filter this page has, and the page cannot work without it:
        // materials belong to a stage, so the stage is chosen first
        const tools = (
            <label className="ui-filter is-inline">
                <span>المرحلة</span>
                <Dropdown
                    value={selectedStage}
                    options={schoolStages}
                    placeholder="اختر"
                    onChange={(e) => this.getMaterialsByStage(e.value)}
                    optionLabel="label"
                    showClear
                    emptyMessage={<SelectEmpty loading={this.state.loadingStages} text="مفيش مراحل" />}
                />
            </label>
        );

        const nameBody = (row) => (
            <span className="ui-row-lead">
                <span className="thumb is-empty" aria-hidden="true">
                    <i className="pi pi-book"></i>
                </span>
                <span className="tx">
                    <b>{row.name}</b>
                    <small>{stage ? stage.name : '—'}</small>
                </span>
            </span>
        );

        const actionBodyTemplate = (rowData) => {
            return (
                <React.Fragment>
                    <Tip text="تعديل">
                        <Button icon="pi pi-pencil" className="p-button-rounded p-button-secondary p-ml-2" onClick={() => this.setState({ visible: true, editableData: { ...rowData } })} />
                    </Tip>
                    <Tip text="حذف">
                        <Button icon="pi pi-trash" className="p-button-rounded p-button-danger" onClick={() => this.setState({ doomed: rowData })} />
                    </Tip>
                </React.Fragment>
            );
        }

        const canAdd = !!(this.state.addStage && String(this.state.userInput || '').trim()) && !this.state.adding;

        return (
            <>
                <Header
                    pageName="المواد"
                    action={{ label: "مادة جديدة", icon: "pi pi-plus", onClick: () => this.setState({ addOpen: true, addStage: this.state.selectedStage }) }}
                />
                <Toast ref={this.toast}></Toast>

                <Confirm
                    visible={!!doomed}
                    onHide={() => this.setState({ doomed: null })}
                    name={doomed ? doomed.name : ''}
                    note="المادة بتتشال من المرحلة دي. لو عليها فترات أو حصص، السيرفر هيرفض الحذف ويقول لك."
                    busy={deleting}
                    onConfirm={() => deleteMaterial(doomed)}
                />

                <div className="content">
                    <div className="container">
                        <div className="card">
                            <Card>
                                <Toolbar
                                    value={this.state.globalFilter || ''}
                                    onSearch={(v) => this.setState({ globalFilter: v })}
                                    placeholder="بحث في المواد"
                                    count={selectedStage && !tableLoading ? `${data.length} مادة` : null}
                                    tools={tools}
                                />

                                <DataTable
                                    sortable
                                    globalFilter={this.state.globalFilter}
                                    className="p-datatable-responsive-demo p-datatable-gridlines p-datatable-striped"
                                    value={data} paginator rows={10} rowsPerPageOptions={[10, 20, 50]}
                                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                                    emptyMessage={
                                        tableLoading ? (
                                            <TableWait />
                                        ) : !selectedStage ? (
                                            <EmptyState
                                                title="اختر مرحلة دراسية"
                                                hint="المواد بتتعرض مرحلة مرحلة — اختار واحدة من فوق وهتشوف موادها هنا"
                                                icon="pi pi-sitemap"
                                            />
                                        ) : (
                                            <EmptyState
                                                title={`مفيش مواد في «${stage ? stage.name : ''}»`}
                                                hint="ضيف أول مادة للمرحلة دي"
                                                icon="pi pi-book"
                                                action={{ label: "مادة جديدة", onClick: () => this.setState({ addOpen: true, addStage: this.state.selectedStage }) }}
                                            />
                                        )
                                    }>
                                    <Column sortable field="name" header="المادة" body={nameBody}></Column>
                                    <Column header="تعديل / حذف" body={actionBodyTemplate}></Column>
                                </DataTable>
                            </Card>
                        </div>
                    </div>

                    {/* a new material: the stage it belongs to, and its name --
                        the same two things the inline row used to ask for,
                        now with room to say which is which */}
                    <Modal
                        visible={this.state.addOpen}
                        onHide={() => this.setState({ addOpen: false })}
                        title="مادة جديدة"
                        width={460}
                        footer={
                            <button
                                type="button"
                                className="ui-btn"
                                disabled={!canAdd}
                                onClick={this.addMaterial}
                            >
                                {this.state.adding ? <i className="pi pi-spin pi-spinner"></i> : <i className="pi pi-plus"></i>}
                                <span>{this.state.adding ? 'جاري الإضافة…' : 'إضافة المادة'}</span>
                            </button>
                        }
                    >
                        <div className="ui-modal-form">
                            <label className="ui-filter">
                                <span>المرحلة الدراسية</span>
                                <Dropdown
                                    value={this.state.addStage}
                                    options={schoolStages}
                                    placeholder="اختر"
                                    onChange={(e) => this.setState({ addStage: e.value })}
                                    optionLabel="label"
                                    emptyMessage={<SelectEmpty loading={this.state.loadingStages} text="مفيش مراحل" />}
                                />
                            </label>

                            <div className="p-inputgroup">
                                <span className="p-float-label">
                                    <InputText
                                        autoFocus
                                        value={this.state.userInput || ''}
                                        onChange={(e) => this.setState({ userInput: e.target.value })}
                                        onKeyDown={(e) => e.key === 'Enter' && canAdd && this.addMaterial()}
                                    />
                                    <label>إسم المادة</label>
                                </span>
                            </div>
                        </div>
                    </Modal>

                    <Modal
                        visible={this.state.visible}
                        onHide={() => this.setState({ visible: false })}
                        title="تعديل المادة"
                        width={460}
                        footer={
                            <button
                                type="button"
                                className="ui-btn"
                                disabled={this.state.saving || !String(this.state.editableData?.name || '').trim()}
                                onClick={editMaterial}
                            >
                                {this.state.saving ? <i className="pi pi-spin pi-spinner"></i> : <i className="pi pi-check"></i>}
                                <span>{this.state.saving ? 'جاري الحفظ…' : 'حفظ التعديل'}</span>
                            </button>
                        }
                    >
                        {this.state.editableData !== null &&
                            <div className="p-inputgroup">
                                <span className="p-float-label">
                                    <InputText
                                        autoFocus
                                        value={this.state.editableData.name}
                                        onChange={(e) => this.setState({ editableData: { ...this.state.editableData, name: e.target.value } })}
                                        onKeyDown={(e) => e.key === 'Enter' && editMaterial()}
                                    />
                                    <label>إسم المادة</label>
                                </span>
                            </div>
                        }
                    </Modal>
                </div>
            </>
        );
    }
}

export default Materials;
